import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/bong/bong/frontend/src/app/authors/AuthorsClient.tsx");
